import React from 'react';
import PropTypes from 'prop-types';

const styleDiv = {
  height: '100%',
  width: '100%',
  position: 'relative'
};

const styleImg = {
  maxHeight: '100%',
  maxWidth: '100%',
  position: 'absolute',
  top: '0',
  bottom: '0',
  left: '0',
  right: '0',
  margin: 'auto'
};

const CenteredImage = ({ containerHeight, containerWidth, src, className, alt }) => (
  <div className={className} style={{ height: containerHeight, width: containerWidth }}>
    <div style={styleDiv}>
      <img style={styleImg} src={src} alt={alt} />
    </div>
  </div>
);

CenteredImage.propTypes = {
  containerHeight: PropTypes.string.isRequired,
  containerWidth: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
  alt: PropTypes.string
};

CenteredImage.defaultProps = {
  className: '',
  alt: ''
};

export default CenteredImage;



// WEBPACK FOOTER //
// ./src/components/CenteredImage.jsx